// TODO: this file should be deprecated in favor of importing straight from
// the entity itself.
import {
    Address,
    DeliveryCheckPayload,
    StreetAddress,
    isAddressEmpty
} from '@lib/entities/Address';
import { Auth, LocalUser, ProfileInfo, User } from '@lib/entities/Auth';
import { CartItem } from '@lib/entities/Cart';
import {
    Ingredient,
    IngredientCategory,
    MenuCategory,
    MenuItem,
    PromotionalTag,
    SeasonalMenu
} from '@lib/entities/Menu';
import * as Orders from '@lib/entities/Order';
import { Order, OrderItem, OrderItemCustomization } from '@lib/entities/Order';
import { CardPayment, CreatePaymentPayload } from '@lib/entities/Payment';
import { Reward } from '@lib/entities/Rewards';
import * as Stores from '@lib/entities/Store';
import { DeliveryType, RemoteStore, RemoteStoreHours, Store } from '@lib/entities/Store';

export * as Carts from '@lib/entities/Cart';

export * as Rewards from '@lib/entities/Rewards';

export type {
    Address,
    StreetAddress,
    DeliveryCheckPayload,
    RemoteStore,
    RemoteStoreHours,
    Store,
    CartItem,
    MenuCategory,
    MenuItem,
    Ingredient,
    IngredientCategory,
    SeasonalMenu,
    Auth,
    User,
    ProfileInfo,
    LocalUser,
    Order,
    OrderItem,
    OrderItemCustomization,
    CreatePaymentPayload,
    CardPayment,
    PromotionalTag,
    Reward
};
export { DeliveryType, Stores, Orders, isAddressEmpty };
